import { Mapper } from "../../../../base/utils/mapper";
import { TipoPlanSaludModel } from "../../../../domain/models/configuration/tipo-plan-salud.model";
import { TipoPlanSaludEntity } from "../entities/tipo-plan-salud.entity";


export class TipoPlanSaludImplementationRepositoryMapper extends Mapper<TipoPlanSaludEntity, TipoPlanSaludModel> {
	mapFrom(param: TipoPlanSaludEntity): TipoPlanSaludModel {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		};
	}
	mapTo(param: TipoPlanSaludModel): TipoPlanSaludEntity {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		}
	}
}